import { supabaseFetch } from './core';

// ============================================
// COMMUNITY (profili pubblici, ricerca)
// Le letture pubbliche passano da RPC SECURITY DEFINER lato DB:
// espongono solo campi safe e solo profili is_public = true.
// ============================================

/**
 * Verifica se uno username è disponibile (escludendo sé stessi).
 * @returns {Promise<boolean>}
 */
export const isUsernameAvailable = async (username, userId) => {
  const clean = (username || '').trim();
  if (!clean) return false;
  try {
    const data = await supabaseFetch('/rpc/is_username_available', {
      method: 'POST',
      body: JSON.stringify({ p_username: clean, p_user_id: userId }),
    });
    // La RPC ritorna un boolean scalare
    return data === true || data === 'true';
  } catch (err) {
    console.warn('[community] isUsernameAvailable error:', err.message);
    return false;
  }
};

/**
 * Cerca profili pubblici per nome o username.
 * @returns {Promise<Array>} campi safe (no email)
 */
export const searchPublicProfiles = async (query) => {
  try {
    const data = await supabaseFetch('/rpc/search_public_profiles', {
      method: 'POST',
      body: JSON.stringify({ q: query || '' }),
    });
    return Array.isArray(data) ? data : [];
  } catch (err) {
    console.warn('[community] searchPublicProfiles error:', err.message);
    return [];
  }
};

/**
 * Segue un atleta (solo profili pubblici, no auto-follow). Ritorna true se ok.
 */
export const followUser = async (targetId) => {
  try {
    const data = await supabaseFetch('/rpc/follow_user', {
      method: 'POST',
      body: JSON.stringify({ p_target: targetId }),
    });
    return data === true || data === 'true';
  } catch (err) {
    console.warn('[community] followUser error:', err.message);
    return false;
  }
};

/**
 * Smette di seguire un atleta. Ritorna true se ok.
 */
export const unfollowUser = async (targetId) => {
  try {
    const data = await supabaseFetch('/rpc/unfollow_user', {
      method: 'POST',
      body: JSON.stringify({ p_target: targetId }),
    });
    return data === true || data === 'true';
  } catch (err) {
    console.warn('[community] unfollowUser error:', err.message);
    return false;
  }
};

/**
 * Conteggi follower/following di un utente (pubblico o proprio).
 * @returns {Promise<{followers:number, following:number}>}
 */
export const getFollowCounts = async (userId) => {
  try {
    const data = await supabaseFetch('/rpc/get_follow_counts', {
      method: 'POST',
      body: JSON.stringify({ p_user_id: userId }),
    });
    const row = Array.isArray(data) ? data[0] : data;
    return {
      followers: row?.followers ?? 0,
      following: row?.following ?? 0,
    };
  } catch (err) {
    console.warn('[community] getFollowCounts error:', err.message);
    return { followers: 0, following: 0 };
  }
};

/**
 * Ottiene il profilo pubblico completo per username (o null se privato/inesistente).
 * @returns {Promise<Object|null>}
 */
export const getPublicProfile = async (username) => {
  const clean = (username || '').trim();
  if (!clean) return null;
  try {
    const data = await supabaseFetch('/rpc/get_public_profile', {
      method: 'POST',
      body: JSON.stringify({ p_username: clean }),
    });
    if (Array.isArray(data)) return data[0] || null;
    return data || null;
  } catch (err) {
    console.warn('[community] getPublicProfile error:', err.message);
    return null;
  }
};
